import type { IntegrationProviderConfig } from '../../types';
import GoogleConnectionCard from './GoogleConnectionCard';
import GoogleIcon from './GoogleIcon';

export const googleConfig: IntegrationProviderConfig = {
  id: 'google',
  name: 'Google',
  icon: GoogleIcon,
  brandColor: '#4285F4',
  authMethod: 'oauth2',
  ConnectionCard: GoogleConnectionCard,
  supportsPull: false,
  supportsPush: false,
  description:
    'Grant access to Google Docs, Sheets, Drive, and Gmail to read and write content from your flows.',
  category: ['productivity', 'storage'],
  keywords: ['docs', 'sheets', 'drive', 'gmail', 'workspace'],
  docsUrl: 'https://developers.google.com/workspace',
  priority: 92,
  supportsSharing: false,
};
